import { render, staticRenderFns } from "./partnerCombo.vue?vue&type=template&id=1fffeec2&scoped=true&"
import script from "./partnerCombo.vue?vue&type=script&lang=js&"
export * from "./partnerCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fffeec2",
  null
  
)

export default component.exports